<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <permission-btn moduleName='Report_PurchasePlan_InvOrder' size="mini" v-on:btn-event="onBtnClicked"></permission-btn>
      </div>
    </sticky>
    <div class="app-container flex-item">
      <div class="bg-white fh" id='txCompareForms-table'>
        <el-table ref="mainTable" :key='tableKey' :data="list" v-loading="listLoading" border fit highlight-current-row
                  style="width: 100%;" height="calc(100% - 52px)" @row-click="rowClick"
                  @selection-change="handleSelectionChange" @sort-change="handleSortChange">
          <!--使用服务器返回的表头，如果复杂的表头和格式解析，请自己定义表格格式-->
          <el-table-column type="selection" align="center" width="55"></el-table-column>
          <el-table-column v-for="(item, index) in headerList" :key="index" :min-width="item.width"
                           :label="item.description"
                           :prop="item.key" :align="item.align" :sortable="item.isSort === true ? 'custom' : false"
                           :show-overflow-tooltip="item.tooltip">
            <template slot-scope="scope">
              <select-type ref="selectType" :isEdit="false" :typeId="item.isSel" v-model="scope.row[item.key]"
                           v-if="item.isSel">
              </select-type>
              <span v-else-if="item.key === 'planCode'">
                  <a class="link-type"
                     @click.stop="openDrawer(scope.row,'txPurchasePlans')">{{ scope.row.planCode }}</a>
                </span>
              <span v-else>
                <span
                  v-if="item.type === 'DateTime'&&item.key !== 'createDate'">{{
                    scope.row[item.key] | dateFormat
                  }}</span>
                <span v-else>{{ scope.row[item.key] }}</span>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :page.sync="listQuery.page"
                    :limit.sync="listQuery.limit" @pagination="handleCurrentChange"/>
      </div>

      <filter-form ref="queryForm" @filter="handleFilter" :code="crmType"
                   :dialog-visible.sync="dialogQueryVisible"/>

      <my-transfer :code="crmType" @filter="handleFilter"
                   :titles="['待配置列', '显示列']"
                   :dialog-visible.sync="dialogSetVisible"/>
      <drawerViews :drawer.sync="drawer" :tempobj="drawertemp" :objtype="drawerobjtype"
                   :menukeyArray="menukeyArray"></drawerViews>

    </div>
  </div>
</template>

<script>
import * as report_purchaseplan_invorder from '@/api/report_purchaseplan_invorder';
import mytable from '@/utils/crmtableFlowV2';
import * as txPurchasePlans from '@/api/tx_purchaseplans';

export default {
  name: 'report_purchaseplan_invorder',
  components: {},
  mixins: [mytable],
  data() {
    return {
      crmType: 'Report_PurchasePlan_InvOrder',
      listQuery: { // 查询条件
        page: 1,
        limit: 20,
        AccountId: '' // 账套ID
      },
      initData: {
        AccountId: ''
      },
      rules: {},
      soltNameArray: ['orderDetail'],
      lstSupply: []
    };
  },
  created() {
    this.initData.AccountId = this.getAccountId(); // 从V2文件中取到账套ID
    this.listQuery.AccountId = this.getAccountId();
  },
  methods: {
    getApi() {
      return report_purchaseplan_invorder;
    },
    btnClickOther(bomid) {
      switch (bomid) {
        case 'btnStock':
          report_purchaseplan_invorder.AsyncStoreState().then(res => {
            this.$message({
              message: '更新状态成功',
              type: 'success'
            });
            this.getList();
          });
          break;
      }
    },
    openDrawer(row, type) { // 打开抽屉
      this.drawerobjtype = type;
      if (type === 'txPurchasePlans') {
        txPurchasePlans.get(row.purchasePlanGuid).then(res => {
          this.drawertemp = { ...this.drawertemp, ...res.result };
          this.menukeyArray = [
            { name: '', menukey: 'tx_purchaseplansview' }
          ]; // 要显示的标签
          this.drawer = true;
        });
      }
    }
  }
};
</script>
<style>
.dialog-mini .el-select {
  width: 100%;
}

/* 防止样式污染，使用id为每个页面定义表格体高度 */
#txCompareForms-table .el-table__body-wrapper {
  height: calc(100% - 57px) !important;
}
</style>
